<!--
 * @Description: 编辑楼盘
 * @Author: 琢磨先生
 * @Date: 2023-12-28 08:56:24
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2026-02-14 21:02:23
-->
<template>
  <el-dialog
    title="明源直连配置"
    v-model="visible"
    width="1000"
    top="5vh"
    :destroy-on-close="true"
    :show-close="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="onClosed"
  >
    <el-scrollbar v-loading="loading">
      <el-form
        :model="form"
        ref="form"
        :rules="rules"
        label-width="160px"
        :inline="false"
      >
        <el-form-item label="项目名称" prop="name">
          <b> {{ form.name }}</b>
        </el-form-item>

        <el-form-item label="开启直连">
          <el-switch v-model="form.isLinkYunke"></el-switch>
          <div class="help-block">开启直连后系统可以通过接口直连明源分销通</div>
        </el-form-item>
        <el-form-item label="自动推送">
          <el-switch v-model="form.isAutoPushYunke"></el-switch>
          <div class="help-block">
            开启自动推送后 07:30-18:30内的报备讲自动推送至明源、否则需要手动推送
          </div>
        </el-form-item>
        
        <el-divider>禁止推送字段</el-divider>

        <el-row>
          <el-col :span="12">
            <el-form-item label="不含带看人姓名">
              <el-switch v-model="form.isDisabledPushDkName"></el-switch>
              <div class="help-block">开启后 将不会推送至明源系统</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="不含带看人手机">
              <el-switch v-model="form.isDisabledPushDkMobile"></el-switch>
              <div class="help-block">开启后 将不会推送至明源系统</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="不含带看公司名称">
              <el-switch v-model="form.isDisabledPushCompany"></el-switch>
              <div class="help-block">开启后 将不会推送至明源系统</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="不含备注">
              <el-switch v-model="form.isDisabledPushRemark"></el-switch>
              <div class="help-block">开启后 将不会推送至明源系统</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="不含到案时间">
              <el-switch v-model="form.isDisabledPushDueTime"></el-switch>
              <div class="help-block">开启后 将不会推送至明源系统</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>备注添加</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="备注添加到案人数">
              <el-switch v-model="form.isRemarkAddDueNumber"></el-switch>
              <div class="help-block">
                开启后 将自动添加到案人数至备注尾部。注：需要在业务员报备前开启
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注添加到案时间">
              <el-switch v-model="form.isRemarkAddDueTime"></el-switch>
              <div class="help-block">
                开启后 将自动添加到案时间至备注尾部。注：需要在业务员报备前开启
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注添加公司名称">
              <el-switch v-model="form.isRemarkAddCompany"></el-switch>
              <div class="help-block">
                开启后 将自动添加公司名称至备注尾部。注：需要在业务员报备前开启
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注添加带看人姓名">
              <el-switch v-model="form.isRemarkAddDaikanren"></el-switch>
              <div class="help-block">
                开启后 将自动添加带看人至备注尾部。 注：需要在业务员报备前开启
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注添加带看人手机">
              <el-switch v-model="form.isRemarkAddDaikanrenMobile"></el-switch>
              <div class="help-block">
                开启后 将自动添加带看人至备注尾部。 注：需要在业务员报备前开启
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注添加客户姓名">
              <el-switch v-model="form.isRemarkAddClientName"></el-switch>
              <div class="help-block">
                开启后 将自动添加客户姓名至备注尾部。注：需要在业务员报备前开启
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注添加客户号码">
              <el-switch v-model="form.isRemarkAddClientMobile"></el-switch>
              <div class="help-block">
                开启后 将自动添加客户号码至备注尾部。 注：需要在业务员报备前开启
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注添加客户性别">
              <el-switch v-model="form.isRemarkAddClientSex"></el-switch>
              <div class="help-block">
                开启后 将自动添加客户性别至备注尾部。 注：需要在业务员报备前开启
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>其它</el-divider>
        <el-form-item label="手机号类型" prop="pushPhoneType">
          <!-- <el-select v-model="form.pushPhoneType" placeholder="" >
            <el-option 
              label="不限制"
              :value="0">
            </el-option> <el-option 
              label="全号"
              :value="1">
            </el-option> <el-option 
              label="隐号"
              :value="0">
            </el-option>
          </el-select> -->
          <el-radio-group v-model="form.pushPhoneType">
            <el-radio :label="0">不限制</el-radio>
            <el-radio :label="1">全号</el-radio>
            <el-radio :label="2">隐号</el-radio>  
          </el-radio-group>
        </el-form-item>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="带看人添加公司名称">
              <el-switch v-model="form.isDaikanrenAppendCompany"></el-switch>
              <div class="help-block">开启后 公司名称将添加至带看人姓名尾部。例如：李四-xxxx公司</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>查询选择开发商项目</el-divider>
        <el-form-item label="直连系统类型" prop="yunkeExterType">
          <el-radio-group v-model="form.yunkeExterType">
            <el-radio :label="2">云客</el-radio>
            <!-- <el-radio :label="3">盟拓</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号码" prop="yunkeYkResidentTel">
          <el-input
            v-model="form.yunkeYkResidentTel"
            style="width: 180px"
            placeholder="开发商报备手机号码"
          ></el-input>
        </el-form-item>

        <el-form-item label="驻场类型" prop="yunkeExterResidentType">
          <el-radio-group v-model="form.yunkeExterResidentType">
            <el-radio :label="1">驻场</el-radio>
            <el-radio :label="2">经纪人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="开发商报备链接"
          v-if="form.yunkeExterType == 2 && form.yunkeExterResidentType == 2"
        >
          <el-input
            v-model="form.yunkeYkRecommendLink"
            placeholder=""
          ></el-input>
          <div>
            <el-text type="info"
              >直连的系统类型选择【云客】时且开发商直连的驻场类型为【经纪人】时必填</el-text
            >
          </div>
        </el-form-item>
        <template v-if="form.yunkeExterType == 3">
          <el-form-item label="盟拓开发商租户标识">
            <el-input
              v-model="form.yunkeExterOrg"
              placeholder=""
              style="width: 200px"
            ></el-input>
            <div class="help-block">直连的系统类型选择【盟拓】时必填</div>
          </el-form-item>
          <el-form-item label="盟拓开发商账号验证信息">
            <el-input
              v-model="form.yunkeResidentPassword"
              placeholder=""
              style="width: 200px"
            ></el-input>
            <div class="help-block">直连的系统类型选择【盟拓】时必填</div>
          </el-form-item>
        </template>

        <el-form-item label="开发商直连项目列表">
          <el-table :data="dataList" border>
            <el-table-column label="" width="80">
              <template #default="{ row }">
                <el-checkbox
                  v-model="row.checked"
                  @change="onCheckChange(row)"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              label="yk项目名称"
              prop="proj_name"
            ></el-table-column>
            <el-table-column label="yk租户号" prop="org_code"></el-table-column>
            <el-table-column label="">
              <template #header>
                <el-button type="primary" icon="search" @click="onSearch"
                  >查询直连项目</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </el-scrollbar>
    <template #footer>
      <el-button type="primary" :loading="saving" @click="onSubmit"
        >确定</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
import common_api from "@/http/common_api";
import branch_api from "@/http/branch_api";
import udfarea_api from "@/http/udfarea_api";
//   import QueryDialog from "@/views/yunke/project/query_dialog.vue";

export default {
  components: {
    //   QueryDialog,
  },
  data() {
    return {
      visible: false,
      saving: false,
      loading: false,
      title: "",
      form: {},
      rules: {
        yunkeExterType: [
          { required: true, message: "请选择直连系统类型", trigger: "change" },
        ],
        yunkeYkResidentTel: [
          {
            required: true,
            message: "请输入开发商报备手机号码",
            trigger: "blur",
          },
        ],
        yunkeExterResidentType: [
          { required: true, message: "请选择驻场类型", trigger: "change" },
        ],
      },
      enums: {},
      branch_list: [], //分部
      udfAreaList: [], //自定义区域
      dataList: [],
    };
  },
  props: {
    id: Number,
    importItem: Object,
  },
  emits: ["closed", "success"],
  watch: {
    id: {
      handler() {
        if (this.id) {
          this.dataList = [];
          this.loadDtl();
          this.visible = true;
          // this.title = "修改";
        }
      },
      immediate: true,
    },
    //   importItem: {
    //     handler() {
    //       if (this.importItem) {
    //         this.visible = true;
    //         this.title = "导入楼盘";
    //         this.form = {
    //           FwwEstateId: this.importItem.id,
    //           estateType: 0,
    //           name: this.importItem.title,
    //           stopStatus: 0,
    //           aheadHour: 0,
    //           aheadMin: 0,
    //           protectDays: 0,
    //           protectHour: 0,
    //           dkSecureDays: 0,
    //           limitNum: 0,
    //           qrAfterMinutes: 0,
    //           qrBeforeHouse: 0,
    //           // attributeId:this.branch_list[0].id,
    //         };
    //       }
    //     },
    //     immediate: true,
    //   },
  },
  created() {
    common_api.get_enums().then((res) => {
      if (res.code == 0) {
        this.enums = res.data;
      }
    });

    branch_api.get_select().then((res) => {
      if (res.code == 0) {
        this.branch_list = res.data;
      }
    });
    udfarea_api.get_select().then((res) => {
      if (res.code == 0) {
        this.udfAreaList = res.data;
      }
    });
  },

  methods: {
    /**
     *
     */
    onClosed() {
      this.$emit("closed");
    },

    // /**
    //  * 云客项目选择返回
    //  * @param row
    //  */
    // onYunkeProjectChange(row) {
    //   // console.log(row);
    //   this.form.yunkeDevProjectId = null;
    //   this.form.yunkeDevProject = null;
    //   if (row) {
    //     this.form.yunkeDevProjectId = row.proj_id;
    //     this.form.yunkeDevProject = row;
    //   }
    // },

    /**
     *
     */
    loadDtl() {
      this.loading = true;
      this.$http
        .get("admin/v1/estate/dtl?id=" + this.id)
        .then((res) => {
          if (res.code == 0) {
            //   this.form = Object.assign({}, res.data);
            this.form = {
              id: res.data.id,
              name: res.data.name,
              isLinkYunke: res.data.isLinkYunke,
              isAutoPushYunke: res.data.isAutoPushYunke,
              yunkeExterType: res.data.yunkeExterType,
              yunkeYkResidentTel: res.data.yunkeYkResidentTel,
              yunkeExterResidentType: res.data.yunkeExterResidentType,
              yunkeYkRecommendLink: res.data.yunkeYkRecommendLink,
              autoPushYunkeBeginTime: res.data.autoPushYunkeBeginTime,
              autoPushYunkeEndTime: res.data.autoPushYunkeEndTime,
              isDisabledPushRemark: res.data.isDisabledPushRemark,
              isRemarkAddDueNumber: res.data.isRemarkAddDueNumber,
              isRemarkAddDueTime: res.data.isRemarkAddDueTime,
              isRemarkAddCompany: res.data.isRemarkAddCompany,
              isRemarkAddDaikanren: res.data.isRemarkAddDaikanren,
              isRemarkAddDaikanrenMobile: res.data.isRemarkAddDaikanrenMobile,
              isRemarkAddClientName: res.data.isRemarkAddClientName,
              isRemarkAddClientMobile: res.data.isRemarkAddClientMobile,
              isRemarkAddClientSex: res.data.isRemarkAddClientSex,
              isDisabledPushCompany: res.data.isDisabledPushCompany,
              isDisabledPushDkMobile: res.data.isDisabledPushDkMobile,
              isDisabledPushDkName: res.data.isDisabledPushDkName,
              isDisabledPushDueTime: res.data.isDisabledPushDueTime,
              isDaikanrenAppendCompany: res.data.isDaikanrenAppendCompany,
              ykProject: res.data.yunkeYkProject,
              pushPhoneType: res.data.pushPhoneType,
            };
            if (res.data.yunkeYkProject) {
              var m = { ...res.data.yunkeYkProject };
              m.checked = true;
              this.dataList = [m];
              //   this.loadCustomField();
            }
          }
        })
        .finally(() => (this.loading = false));
    },

    /**
     * 查询直连项目
     */
    onSearch() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saving = true;

          this.$http
            .post("admin/v1/yunkeproject/ykprojects", {
              exter_type: this.form.yunkeExterType,
              mobile_tel: this.form.yunkeYkResidentTel,
              exter_resident_type: this.form.yunkeExterResidentType,
              yk_recommend_link: this.form.yunkeYkRecommendLink,
            })
            .then((res) => {
              if (res.code === 0 && res.data && res.data.length) {
                this.isSubmit = false;
                this.dataList = res.data;
                this.dataList.forEach((item) => {
                  item.checked = false;
                });
              }
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },

    /**
     *
     * @param row
     */
    onCheckChange(row) {
      this.dataList.forEach((item) => {
        if (item.proj_id != row.proj_id) {
          item.checked = false;
        }
      });
      this.form.ykProject = row.checked ? { ...row } : null;
      //   this.loadCustomField();
      //   this.$emit("change", row.checked ? { ...row } : null);
    },

    // /**
    //  * 加载自定义字段
    //  */
    // loadCustomField() {
    //   if (this.form.ykProject) {
    //     this.$http
    //       .get(
    //         "admin/v1/estate/yunke/custom_field?id=" +
    //           this.id +
    //           "&project_id=" +
    //           this.form.
    //       )
    //       .then((res) => {
    //         if (res.code == 0) {
    //           this.custom_fields = res.data;
    //         }
    //       });
    //   }
    // },

    /**
     * 提交
     */
    onSubmit() {
      if (
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.form.ykProject) {
              this.$message.error("请选择直连项目");
              return;
            }
            this.saving = true;
            this.$http
              .post("admin/v1/estate/set_yunke", this.form)
              .then((res) => {
                if (res.code == 0) {
                  this.visible = false;
                  this.$message.success(res.msg);
                } else {
                  this.$message.danger(res.msg);
                }
              })
              .finally(() => (this.saving = false));
          }
        })
      );
    },
  },
};
</script>

<style scoped></style>
